
import React from 'react';

import { Link } from 'react-router-dom';

function StandardsIndexPage() {
  const foundationalControls = [
    { id: 'AI-ABND-1.0', title: 'Documented Accountability Boundaries', description: 'The prerequisite standard. Defines the operational limits of AI operations.', link: '/standards/ai-abnd-1-0', isMandatory: true },
    { id: 'AI-HITL-1.0', title: 'Human Authority and Escalation', description: 'Mandates specific triggers for human intervention.', link: '/standards/ai-hitl-1-0' },
    { id: 'AI-ACCT-1.0', title: 'Outcome Accountability Mapping', description: 'Requires every AI output to be mapped to a liable human role.', link: '/standards/ai-acct-1-0' },
    { id: 'AI-READ-1.0', title: 'Readiness and Incident Response', description: 'Standardized procedures for identifying and remediating AI failures.', link: '/standards/ai-read-1-0' },
    { id: 'AI-PERF-1.0', title: 'Performance Monitoring and Change Control', description: 'Protocols for logging modifications to system prompts.', link: '/standards/ai-perf-1-0' },
    { id: 'AI-ROI-1.0', title: 'Responsibility Domain Mapping', description: 'Explicit definition of boundaries for AI responsibility.', link: '/standards/ai-roi-1-0' },
    { id: 'AI-DISC-1.0', title: 'Client Disclosure and Transparency', description: 'Mandatory clear-language disclosure of system capabilities.', link: '/standards/ai-disc-1-0' }
  ];

  return (
    <>

      <div className="max-w-6xl mx-auto py-12 px-6">
        <h1 className="text-3xl font-bold text-[#102A43] mb-6 border-b border-gray-200 pb-4">AASC Standards</h1>
        
        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#102A43] mb-4">Introduction</h2>
          <p className="text-lg text-gray-800 leading-relaxed mb-4">
            The AASC Standards Framework provides the technical definitions required for the safe and accountable operation of any organization using AI.
          </p>
           <div className="bg-[#F9FAFB] p-4 border border-gray-200 text-sm text-[#64748B]">
             <p><strong>AASC Accountability Declaration:</strong> Self-attested governance documentation with annual renewal and public registry listing.</p>
           </div>
        </section>

        <section className="mb-12">
          <h2 className="text-2xl font-bold text-[#102A43] mb-6 uppercase tracking-wide">Foundational Standards (AASC 2.0)</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {foundationalControls.map((control) => (
              <div key={control.id} className={`bg-white border ${control.isMandatory ? 'border-blue-200 shadow-md' : 'border-gray-200'} p-6 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow relative`}>
                {control.isMandatory && <div className="absolute top-0 right-0 bg-[#2F80ED] text-white text-[10px] uppercase font-bold px-2 py-1">Prerequisite</div>}
                <div className="mb-4">
                  <span className={`inline-block ${control.isMandatory ? 'bg-blue-100 text-[#2F80ED]' : 'bg-gray-100 text-gray-800'} text-xs font-mono font-bold px-2 py-1 rounded-sm mb-2`}>{control.id}</span>
                  <h3 className="text-xl font-bold text-[#102A43]">{control.title}</h3>
                </div>
                <p className="text-[#64748B] text-sm mb-6 flex-grow">{control.description}</p>
                <div className="pt-4 border-t border-gray-100 mt-auto">
                   <Link to={control.link} className="text-[#2F80ED] font-bold text-sm hover:underline">View Standard Requirements →</Link>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-[#F9FAFB] p-6 border border-gray-200 flex flex-col md:flex-row gap-8 justify-between items-center">
          <div>
            <h2 className="text-lg font-bold text-[#102A43] mb-2">Standards Resources</h2>
            <p className="text-sm text-[#64748B]">Access technical documentation and historical versions.</p>
          </div>
          <div className="flex gap-4">
             <Link to="/standards-taxonomy" className="px-4 py-2 bg-white border border-[#E2E8F0] text-[#64748B] font-bold text-sm rounded-sm hover:bg-gray-100">Taxonomy</Link>
             <Link to="/framework-alignment" className="px-4 py-2 bg-white border border-[#E2E8F0] text-[#64748B] font-bold text-sm rounded-sm hover:bg-gray-100">Alignment</Link>
          </div>
        </section>
      </div>
    </>
  );
}

export default StandardsIndexPage;
